var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElNotAllowedLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM3.408 9.17777C3.02218 8.54276 2.8 7.79733 2.8 7C2.8 4.6804 4.6804 2.8 7 2.8C7.79733 2.8 8.54276 3.02218 9.17777 3.408L3.408 9.17777ZM4.82221 10.592C5.45722 10.9778 6.20266 11.2 7 11.2C9.3196 11.2 11.2 9.3196 11.2 7C11.2 6.20266 10.9778 5.45722 10.592 4.82221L4.82221 10.592Z",
    fill: "#222222",
    fillOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElNotAllowedLight);
export default __webpack_public_path__ + "static/media/el-not-allowed-light.6c763b2c79afab62d9ef581188754eeb.svg";
export { ForwardRef as ReactComponent };